import axios from 'axios'
// import qs from 'qs'

export const leapsChallengesService = ({
  getLeapsChallengeList (token) {
    return axios.get('/api/leaps/challenges', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getLeapsReflectionList (token, groupId) {
    return axios.get('/api/MeetingMentorReflection?groupId=' + groupId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  createLeapsChallenge (token, leapsChallengeObj) {
    // var stringifiedObj = qs.stringify(leapsChallengeObj)
    return axios.post('/api/leaps/challenges/create', leapsChallengeObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  updateLeapsChallenge (token, leapsChallengeObj) {
    // var stringifiedObj = qs.stringify(leapsChallengeObj)
    return axios.put('/api/leaps/challenges/put', leapsChallengeObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  deleteLeapsChallenge (token, challengeLibraryId) {
    return axios.delete('/api/leaps/challenges/delete?challengeID=' + challengeLibraryId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteCurrentReflectionQuestion (token, meetingMentorReflectionId) {
    return axios.delete('/api/MeetingMentorReflection?meetingMentorReflectionId=' + meetingMentorReflectionId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateCurrentReflectionQuestion (token, leapsQuestionObj) {
    return axios.put('/api/MeetingMentorReflection', leapsQuestionObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/leaps-challenges-service.js